import { Spin } from 'antd';
import React, { Suspense } from 'react';
import { AuthenticationWrap } from './overview/style';

const AuthLayout = (WraperContent) => {
  return function () {
    return (
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <div className="auth-container">
          <AuthenticationWrap
            style={{ backgroundImage: `url("${require('../../../static/img/admin-bg-light.png')}")` }}
          >
            <div className="ninjadash-authentication-wrap">
              <WraperContent />
            </div>
          </AuthenticationWrap>
        </div>
      </Suspense>
    );
  };
};

export default AuthLayout;
